<div
   class="small-card"
   role="button"
   tabindex="0"
   (click)="handleClick()"
   (keydown.enter)="handleClick()"
   (keydown.space)="handleClick()"
>
  <div class="small-card__header">
    <p class="small-card__header__title">
      {{ title() | translate }}
    </p>
    <mat-icon [svgIcon]="icon()" />
  </div>

  <div class="small-card__image">
    <img
      priority
      alt="{{ title() | translate }}"
      height="177"
      width="266"
      [ngSrc]="imageSrc()"/>
  </div>
</div>
